import { createContext } from 'react'
import { PlanTypeSelectorContextType } from '../types'

export const PlanTypeSelectorContext = createContext<PlanTypeSelectorContextType>(
  null
)
